import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface PublicationDateProps {
  publicationDate: Date;
}

const PublicationDate: React.FC<PublicationDateProps> = (props) => {
  const { t } = useTranslation();

  const { publicationDate } = props;

  const renderPublicationDate = useMemo(() => {
    const translationBase = 'components.article_metadata.publication_date';

    return t(`${translationBase}`, {
      publicationDate,
      formatParams: {
        publicationDate: {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        },
      },
    });
  }, [publicationDate, t]);

  return (
    <time className="PublicationDate" dateTime={publicationDate.toUTCString()}>
      {renderPublicationDate}
    </time>
  );
};

export default PublicationDate;
